import React from 'react';
import { CompanyProvider } from './CompanyContext';

/**
 * ReferralAppProvider
 * Wrap referral application tree with required context providers.
 * Extend here in future (e.g. theme, query client) without changing import sites.
 */
const ReferralAppProvider = ({ children, initialCompanyName, initialCompanyLogo }) => {
	return (
		<CompanyProvider initialName={initialCompanyName} initialLogo={initialCompanyLogo}>
			{children}
		</CompanyProvider>
	);
};

export default ReferralAppProvider;
